import { Paper } from '@material-ui/core';
import styled from 'styled-components';

export const GraphGrid = styled(Paper).attrs({
  elevation: 3,
})`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  height: 400px;
  padding-top: 1rem;
`;
